'use client';
import { ppidApi } from '@/services/API';
import recapSliceReducer from '@/store/slices/recapSlice';
import selectedSteReducer from '@/store/slices/steSlice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import authReducer from './slices/authSlice';
import confReducer from './slices/confSlice';
import resetPwdSliceReducer from './slices/pwdResetSlice';

const persistConfig = {
  key: 'root',
  storage,
};

const rootReducer = combineReducers({
  recapSlice: recapSliceReducer,
  selectedSte: selectedSteReducer,
  resetPwdSlice: resetPwdSliceReducer,
  [ppidApi.reducerPath]: ppidApi.reducer,
  auth: authReducer,
  conf: confReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(ppidApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
